import React from "react";

import { useHistory } from "react-router";
import Tippy from "@tippyjs/react";

import { longDate } from "../../utils/DateHelper";
import { PRODUCT_TYPES } from "../../utils/constants";
import { Trans } from "react-i18next";
import { getEncodedValue } from "../../utils/Helpers";

const ProductCard = ({ product }) => {
    const history = useHistory();
    const getProductName = () => {
        return getEncodedValue(product?.id || product?.value);
    };

    return (
        <>
            <div
                onClick={() => {
                    history.push({
                        pathname: `/store/product/${getProductName()}`,
                        state: { from: location.pathname },
                    });
                }}
                className="market-features-card card-table shadow basic-border rounded flex cursor-pointer"
            >
                {product?.promoted && (
                    <img
                        src={
                            require("../../assets/images/special-price.png")
                                .default
                        }
                        className="img-special-price"
                        alt="Market Card"
                    />
                )}
                <div className="market-img image-text-container">
                    <img src={product?.image} alt="Market Card" />
                    {product?.type === PRODUCT_TYPES.bundle && (
                        <div className="top-left-text">
                            <div className="tag-ele tag-bundle px-2 uppercase">
                                <Trans i18nKey="bundle">bundle</Trans>
                            </div>
                        </div>
                    )}
                </div>
                <div className="market-info">
                    <div className="rate-items flex items-center justify-between flex-wrap mb-6">
                        <div className="text-primary-orange">
                            <span className="uppercase text-xxs text-secondary-color-lighter-blue">
                                version{" "}
                            </span>
                            {product?.version}
                        </div>
                        <div className="market-downloaded-number">
                            {longDate(product?.publishedAt)}
                        </div>
                    </div>
                    <div className="market-header mb-2">
                        <h3 className="medium-title-bold">
                            {product?.productName}
                        </h3>
                        <span className="market-item-type success">
                            <Tippy
                                content={product?.materialNames?.join(", ")}
                                placement="top"
                                animation="scale"
                            >
                                <span
                                    tabIndex="0"
                                    className="w-44 block truncate block tooltip-container"
                                >
                                    {product?.materialNames?.join(", ")}
                                </span>
                            </Tippy>
                        </span>
                    </div>
                    <div className="model-description-wrapper">
                        <p className="model-description">
                            {product?.description}
                        </p>
                    </div>

                    <div className="market-prods flex items-center justify-between">
                        <div className="market-item-prod flex items-center">
                            <div className="img-with-circle">
                                <img
                                    src={
                                        product?.organization?.image ||
                                        require("../../assets/images/org-avatar.png")
                                            .default
                                    }
                                    alt={product?.organization?.name}
                                />
                            </div>
                            <h6 className="capitalize blue-color">
                                {product?.organization?.name}
                            </h6>
                        </div>

                        <button className="default-orange-outline-btn">
                            <i className="fas fa-arrow-right cursor-pointer"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductCard;
